jQuery(function () {
    (() => {

        let originalTheme;

        window.addEventListener("beforeprint", () => {

            // Save current theme
            originalTheme = document.documentElement.getAttribute("data-theme");

            // Force light theme for printing
            document.documentElement.setAttribute("data-theme", "light");
        });

        window.addEventListener("afterprint", () => {
            // Restore original theme
            if (originalTheme) {
                document.documentElement.setAttribute("data-theme", originalTheme);
            }
        });
    })();
});
